import React from "react";
import { motion } from "framer-motion";
import "../Components/Styles/Footer.scss";

const Footer: React.FC = () => {
  return (
    <motion.footer className="Footer">
      <motion.div className="LegalCopyrightWrapper">
        <p>©{new Date().getFullYear()} Apollo IT/DATA</p>
        <p>Všechna práva vyhrazena</p>
      </motion.div>
    </motion.footer>
  );
};

export default Footer;
